import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  loading?: boolean;
  children: ReactNode;
}

const BASE: React.CSSProperties = {
  padding: '8px 16px',
  borderRadius: 10,
  border: '1px solid transparent',
  fontSize: 'var(--fs-body)',
  fontWeight: 'var(--fw-medium)',
  cursor: 'pointer',
  minHeight: 44,
  transition: 'opacity 0.15s',
};

const VARIANTS: Record<Variant, React.CSSProperties> = {
  // DESIGN.md: one primary style everywhere (was navy #0f2d64 here, gradient elsewhere).
  primary: { background: 'var(--primary)', color: '#fff', borderColor: 'var(--primary)' },
  secondary: { background: 'transparent', color: 'var(--text)', borderColor: 'var(--line)' },
  ghost: { background: 'transparent', color: 'var(--accent)', borderColor: 'transparent' },
  danger: { background: '#e74c3c', color: '#fff', borderColor: '#e74c3c' },
};

export function Button({
  variant = 'primary',
  loading = false,
  disabled,
  style,
  children,
  ...rest
}: ButtonProps) {
  const isDisabled = disabled || loading;
  return (
    <button
      {...rest}
      disabled={isDisabled}
      style={{
        ...BASE,
        ...VARIANTS[variant],
        opacity: isDisabled ? 0.6 : 1,
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        ...style,
      }}
    >
      {loading ? '…' : children}
    </button>
  );
}
